// Get Bootstrap 4.1
import './../scss/bootstrap-customize.scss';

window.$ = window.jQuery = require('jquery'); // @node Restart `npm run serve` after add it
window.Popper = require('popper.js').default;
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';
